import { jsx as t } from "react/jsx-runtime";
import * as o from "react";
import { P as l } from "../../index-CpDnqHCm.js";
import { c as m } from "../../index-CvSFHqCB.js";
import { c as n } from "../../utils-BOFVZgHd.js";
var d = "Label", s = o.forwardRef((e, r) => /* @__PURE__ */ t(
  l.label,
  {
    ...e,
    ref: r,
    onMouseDown: (a) => {
      a.target.closest("button, input, select, textarea") || (e.onMouseDown?.(a), !a.defaultPrevented && a.detail > 1 && a.preventDefault());
    }
  }
));
s.displayName = d;
var i = s;
const f = m(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
), c = o.forwardRef(({ className: e, ...r }, a) => /* @__PURE__ */ t(i, { ref: a, className: n(f(), e), ...r }));
c.displayName = i.displayName;
export {
  c as Label,
  f as labelVariants
};
//# sourceMappingURL=label.js.map
